<div class="surface-overlay py-3 px-6 shadow-2 flex align-items-center justify-content-between relative lg:static"
    style="min-height: 80px" (notificaCambioDatiEvent)="onNotificaCambioDatiEvent($event)">
    
    <img src="assets/loghi/flowdy2/flowdy2_logo.png" alt="Image" height="40" class="mr-0 lg:mr-2 align-self-center" style="cursor: pointer;" (click)="goToHome()">
   
    <a pRipple class="cursor-pointer block lg:hidden text-700" pStyleClass="@next" enterClass="hidden"
        leaveToClass="hidden" [hideOnOutsideClick]="true"
        (click)="openMenu()">
        <i class="pi pi-bars text-4xl"></i>
    </a>
   
    <div [hidden]="hideMenu"
        class="align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none"
        >
        <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row" 
        >
       
            <li *ngIf="(this.isAdmin || this.isSuperAdmin ||  this.isDemo || this.isPresidioSF) && auth.user$ | async as user" class="lg:relative">
                <a pRipple
                    class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                    style="z-index: 9999;"
                    pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                    leaveActiveClass="fadeout" [hideOnOutsideClick]="true" 
                    (click)="openMenu()">
                    <i class="pi pi-list mr-2" style="color: thistle"></i>
                    <span >Anagrafiche</span>
                    <i class="pi pi-angle-down ml-auto lg:ml-3"></i>
                </a>
                <ul [hidden]="hideMenu"
                    class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"> 
                
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openAnagraficaCentrali()">
                            <i class="pi pi-database mr-2"></i>
                            <span >Centrali</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openAnagraficaComuni()">
                            <i class="pi pi-building mr-2"></i>
                            <span >Comuni</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openAnagraficaImprese()">
                            <i class="pi pi-cart-plus mr-2"></i>
                            <span >Imprese</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openAnagraficaUtenti()">
                            <i class="pi pi-users mr-2"></i>
                            <span >Utenti</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li *ngIf="(this.userService.isSuperAdmin || this.userService.isAdmin || this.userService.isSF || this.userService.isContabile || this.userService.isDirigentePacchetti || this.userService.isDemo) && auth.user$ | async as user" class="lg:relative">
                <a pRipple
                    class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                    style="z-index: 9999;"
                    pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                    leaveActiveClass="fadeout" [hideOnOutsideClick]="true" 
                    (click)="openContabileMenu()">
                    <i class="pi pi-book mr-2" style="color: rgb(10, 112, 116)"></i>
                    <span >Contabile</span>
                    <i class="pi pi-angle-down ml-auto lg:ml-3"></i>
                </a>
                <ul [hidden]="hideContabileMenu"
                    class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"> 
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openListinoPrezzi()">
                            <i class="pi pi-euro mr-2"></i>
                            <span >Listino Prezzi</span>
                        </a>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openODA()">
                            <i class="pi pi-credit-card mr-2"></i>
                            <span >ODA</span>
                        </a>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openBEF()">
                            <i class="pi pi-cart-arrow-down mr-2"></i>
                            <span >BEF</span>
                        </a>
                    </li>
                </ul>
                
            </li>
             <li *ngIf="(checkBando1() || checkBando2()) && auth.user$ | async as user " class="lg:relative">
                <a pRipple
                        class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                        style="z-index: 9999;"
                        pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                        leaveActiveClass="fadeout" [hideOnOutsideClick]="true" 
                        (click)="openRegistriMenu()"
                    >
                    <i class="pi pi-clipboard mr-2" style="color: rgb(11, 80, 26);"></i>
                    <span>Pratiche</span>
                    <i class="pi pi-angle-down ml-auto lg:ml-3"></i>
                </a>
                <ul [hidden]="hidePraticheMenu"
                    class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer"> 
                    <li *ngIf="checkBando1()" class="relative">
                         <a pRipple class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true"
                            (click)="openPraticheBando1Menu()">
                            <!--   <i class="material-symbols-outlined mr-2" style="color: cadetblue"> school </i> -->
                        
                            <span  style="color: cadetblue">Bando 1</span>
                            <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>
                        </a>
                        <ul [hidden]="hidePraticheBando1Menu"
                            class="list-none py-0 pl-3 m-0 lg:px-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">
                            <li *ngIf="checkBando1()">
                                <a pRipple 
                                        (click)="openPratiche('1', 'fase-1')"
                                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                    <i class="material-symbols-outlined mr-2" style="color:cadetblue"> visibility </i>
                                    <span  style="color:cadetblue">Fase 1</span>
                                </a>
                            </li>
                            <!-- <li *ngIf="checkBando1()">
                                <a pRipple 
                                        (click)="openPratiche('1', 'prontofibra')"
                                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                    <i class="material-symbols-outlined mr-2" style="color:cadetblue"> cable </i>
                                    <span  style="color:cadetblue">ProntoFibra</span>
                                </a>
                            </li> -->
                            <li *ngIf="checkBando1()">
                                <a pRipple 
                                        (click)="openPratiche('1', 'fase-2')"
                                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                    <i class="material-symbols-outlined mr-2" style="color:cadetblue"> router </i>
                                    <span  style="color:cadetblue">Fase 2</span>
                                </a>
                            </li>
                            <li *ngIf="checkBando1()">
                                <a pRipple 
                                        (click)="openPratiche('1', 'fase-3')"
                                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                    <i class="material-symbols-outlined mr-2" style="color:cadetblue"> draw </i>
                                    <span  style="color:cadetblue">Fase 3</span>
                                </a>
                            </li>
                            <li *ngIf="checkBando1()">
                                <a pRipple  (click)="openPratiche('1', 'ko')"
                                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                    <i class="material-symbols-outlined mr-2" style="color:cadetblue"> cancel </i>
                                    <span  style="color:cadetblue">KO</span>
                                </a>
                            </li>
                        </ul> 
                     
                    </li>
                    <li *ngIf="checkBando2()" class="relative">
                        <a pRipple class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true"
                            (click)="openPraticheBando2Menu()">
                                <!-- <i class="material-symbols-outlined mr-2" style="color: cornflowerblue"> school </i> -->
                                <span  style="color: cornflowerblue">Bando 2</span>
                                <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>
                            </a>
                               <ul [hidden]="hidePraticheBando2Menu"  class="list-none py-0 pl-3 m-0 lg:px-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">
                                    <li *ngIf="checkBando2()">
                                        <a pRipple  (click)="openPratiche('2', 'fase-1')"
                                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                            <i class="material-symbols-outlined mr-2" style="color:cornflowerblue"> visibility </i>
                                            <span  style="color:cornflowerblue">Fase 1</span>
                                        </a>
                                    </li>
                                    <!-- <li *ngIf="checkBando2()">
                                        <a pRipple  (click)="openPratiche('2', 'prontofibra')"
                                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                            <i class="material-symbols-outlined mr-2" style="color:cornflowerblue"> cable </i>
                                            <span  style="color:cornflowerblue">ProntoFibra</span>
                                        </a>
                                    </li> -->
                                    <li *ngIf="checkBando2()">
                                        <a pRipple  (click)="openPratiche('2', 'fase-2')"
                                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                            <i class="material-symbols-outlined mr-2" style="color:cornflowerblue"> router </i>
                                            <span  style="color:cornflowerblue">Fase 2</span>
                                        </a>
                                    </li>
                                    <li *ngIf="checkBando2()">
                                        <a pRipple  (click)="openPratiche('2', 'fase-3')"
                                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                            <i class="material-symbols-outlined mr-2" style="color:cornflowerblue"> draw </i>
                                            <span  style="color:cornflowerblue">Fase 3</span>
                                        </a>
                                    </li>
                                    <li *ngIf="checkBando2()">
                                        <a pRipple  (click)="openPratiche('2', 'ko')"
                                            class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                                            <i class="material-symbols-outlined mr-2" style="color:cornflowerblue"> cancel </i>
                                            <span  style="color:cornflowerblue">KO</span>
                                        </a>
                                    </li>
                               </ul>
                    
                   </li>
                   
                   
                </ul>
                
            </li> 
            <li *ngIf="((this.isAdmin || this.isSuperAdmin || this.isPresidioSF || this.isImpresa || this.isDemo) && !this.isPM && !this.isPresidioTIM)  && auth.user$ | async as user" class="lg:relative">
                <a pRipple 
                        (click)="openProntofibra()"
                    class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors">
                    <i class="material-symbols-outlined mr-2" style="color:#1f76a5"> cable </i>
                    <span  style="color:#1f76a5">ProntoFibra</span>
                </a>
            </li>
             <li *ngIf="((this.isAdmin || this.isSuperAdmin || this.isPresidioSF || this.isImpresa || this.isDemo) && !this.isPM && !this.isPresidioTIM)  && auth.user$ | async as user" class="lg:relative">
                <a pRipple
                    class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                    style="z-index: 9999;"
                    pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                    leaveActiveClass="fadeout" [hideOnOutsideClick]="true"
                    (click)="openMagazzinoMenu()">
                    <i class="material-symbols-outlined mr-2"> two_pager_store </i>
<!--                    <i class="pi pi-book mr-2" style="color: rgb(10, 112, 116)"></i>-->
                    <span >Magazzino</span>

                    <i class="pi pi-angle-down ml-auto lg:ml-3"></i>
                </a>
                <ul [hidden]="hideMagazzinoMenu"
                    class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openMagazzinoPageListing()">
                            <i class="pi pi-warehouse mr-2"></i>

<!--                            <i class="pi pi-credit-card mr-2"></i>-->
                            <span >Magazzini</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openMagazzinoPageScorte()">
<!--                            <i class="pi pi-euro mr-2"></i>-->
                            <i class="material-symbols-outlined mr-2"> shelves </i>
<!--                            <i class="material-symbols-outlined mr-2"> delivery_truck_speed </i>-->

                            <span >Scorte Imprese</span>
                        </a>
                    </li>
                    <li>
                        <a pRipple
                            class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                            (click)="openMagazzinoPageScuole()">
<!--                            <i class="pi pi-euro mr-2"></i>-->
<!--                            <i class="material-symbols-outlined mr-2"> delivery_truck_speed </i>-->
                            <i class="material-symbols-outlined mr-2"> shelves </i>

                            <span >Scorte Scuole</span>
                        </a>
                    </li>
                    <li class="lg:relative">
                        <a pRipple
                        class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                        (click)="openMagazzinoPageMovimentazioni()">
                            <i class="pi pi-truck mr-2"></i>
<!--                            <i class="material-symbols-outlined mr-2"> delivery_truck_speed </i>-->
                            <span >Movimentazioni</span>
                        </a>
                    </li>
                    <li *ngIf="this.isAdmin || this.isPresidioSF || this.isPresidioTIM">
                        <a pRipple
                                class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 border-round cursor-pointer transition-colors transition-duration-150"
                                style="z-index: 9999;"
                                pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                                leaveActiveClass="fadeout" [hideOnOutsideClick]="true"
                            >
<!--                            <i class="pi pi-credit-card mr-2"></i>-->
<!--                            <i class="material-symbols-outlined mr-2"> delivery_truck_speed </i>-->
                            <i class="pi pi-truck mr-2"></i>
                            <span>Movimentazioni Imprese</span>
                            <i class="pi pi-angle-down ml-auto lg:-rotate-90"></i>
                        </a>
                        <ul [hidden]="false" class="list-none py-0 pl-3 m-0 lg:px-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer left-100 top-0">
                            <li *ngFor="let impresa of imprese">
                                <a pRipple
                                    class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors transition-duration-150"
                                    (click)="openMagazzinoPageMovimentazioni(impresa.id)">
<!--                                    <i class="pi pi-credit-card mr-2"></i>-->
                                    <span >{{ impresa.ragioneSociale }}</span>
                                </a>
                            </li>

                        </ul>

                    </li>

                </ul>
            </li>
        </ul>

       
        <div *ngIf="auth.user$ | async as user" class="flex align-items-start ml-auto">
            <p-chip class="mr-3" *ngIf="!hideChip"  (click)="changeLog()" >
                <div class="p-2 font-bold" [style.color]="'#A0B9C6'" style="cursor: pointer;" pTooltip="Scarica il changelog" tooltipPosition="top">v{{ appVersion }}</div>
            </p-chip>
          <!--   <span class="mr-1 p-1 text-white text-sm font-semibold border-round hidden lg:inline text-navbar" style="background-color: #6c092c;">
                
            </span> -->
            <p-chip *ngIf="!hideChip" >
                <div class="p-2 font-bold" [style.color]="isDemo ? '#478978' : chipColor">{{navbarChip}}</div>
            </p-chip>
        </div>

        <ul
            class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none"
            >
            
          
            <li class="border-top-1 border-gray-800 lg:border-top-none text-gray-400"
            *ngIf="(auth.isAuthenticated$ | async) === false">
            <a pRipple
            class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150"
            pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
            leaveActiveClass="fadeout" [hideOnOutsideClick]="true"
                (click)="loginWithRedirect()">
                <i class="pi pi-sign-in text-base lg:text-2xl mr-2 lg:mr-0"></i>
                <span class="block lg:hidden font-medium">Login</span>
            </a>
        </li>
            <li *ngIf="auth.user$ | async as user" class="lg:relative">
                <button class="p-link layout-topbar-button" (click)="logout()"  pTooltip="Logout" tooltipPosition="top">
                    <i class="pi pi-sign-out"></i>
                    <span>Logout</span>
                </button>
                <!-- <a pRipple
                    class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150"
                    pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                    leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                        <img [src]="user.picture" class="mr-3 lg:mr-0 rounded-circle"
                            style="width: 28px; height: 28px; border-radius: 50%" />
                        <i class="pi pi-angle-down ml-auto lg:ml-3"></i>
                </a>
                <ul
                class="list-none py-3 px-6 m-0 lg:px-0 lg:py-0 border-round shadow-0 lg:shadow-2 lg:border-1 border-50 lg:absolute surface-overlay hidden origin-top w-full lg:w-15rem cursor-pointer">
                <li class="relative">
                    <a *ngIf="((this.userService.isSuperAdmin || this.userService.isAdmin) || (this.isAdmin || this.isSuperAdmin || this.isPresidioSF))"pRipple
                        pRipple
                        class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150"
                        pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                        leaveActiveClass="fadeout" [hideOnOutsideClick]="true" (click)="changeLog()">
                            <i class="pi pi-file-import mr-2"></i>
                            <span >Changelog</span>

                        </a>
                        <a pRipple
                        pRipple
                        class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150"
                        pStyleClass="@next" enterClass="hidden" enterActiveClass="scalein" leaveToClass="hidden"
                        leaveActiveClass="fadeout" [hideOnOutsideClick]="true" (click)="logout()">
                            <i class="pi pi-sign-out mr-2"></i>
                            <span >Logout</span>

                        </a>
                    </li>
                </ul> -->
            </li>

        </ul>
    </div>
</div>